export default __webpack_public_path__ + "static/mcc_defaultAuthor-fe3defca4a6014894b8be05b3821cc10.png";